module.exports = __webpack_public_path__ + "img/undraw_subscriptions_re_k7jj.45f18eda.svg";